import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface ClassSelectioValues {
  sameClassForAll: boolean | null
  planPeriodId?: string
}

const classSelectionApi = (classSelectionValues: ClassSelectioValues): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/BenefitDesign/ClassSelection', classSelectionValues)
}

export default classSelectionApi
